import { render, staticRenderFns } from "./DeclineEmail.vue?vue&type=template&id=6f480bda&scoped=true"
import script from "./DeclineEmail.vue?vue&type=script&lang=js"
export * from "./DeclineEmail.vue?vue&type=script&lang=js"
import style0 from "./DeclineEmail.vue?vue&type=style&index=0&id=6f480bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f480bda",
  null
  
)

export default component.exports